import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../api/axios";
import { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import linkd from "../../assets/social/Linkedin (1).png";
import useAuth from "../../hooks/useAuth";
import QuillResizeImage from "quill-resize-image";
import { useNavigate } from "react-router-dom";

Quill.register("modules/resize", QuillResizeImage);

export default function BlogpostLayout() {
  const languagePrefix = window.location.pathname.startsWith("/nl")
    ? "/nl"
    : window.location.pathname.startsWith("/de")
    ? "/de"
    : "";

  const { post_id } = useParams();
  //   const post = posts.find((post) => post?.id === parseInt(post_id, 10));

  const [post, setPost] = useState({});
  const [title, setTitle] = useState("");
  const { auth, username } = useAuth();
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const res = await axios.get("/blog-web", {
          params: { username },
        });

        // Filter blogs where user_id === author_id
        const userBlogs = res.data;

        setBlogs(userBlogs);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    getBlogs();
  }, [username, auth?.user_id]);

  useEffect(() => {
    const getBlogs = () => {
      axios
        .get(`/blog/${post_id}`)
        .then(async (res) => {
          setPost(res.data);

          let postData = res.data;
          setTitle(postData.title);
          console.log(postData.title);
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
        });
    };

    getBlogs();
  }, [username, post_id]);

  if (!post) {
    return (
      <div>
        {languagePrefix === "/nl"
          ? "Helaas, deze blogpost bestaat niet"
          : languagePrefix === "/de"
          ? "Leider gibt es diesen Blogbeitrag nicht"
          : "Unfortunately, the blogpost you were searching for does not exist"}
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  return (
    <>
      <div className="container ">
        <div className="blog-image-container">
          <img className="blog-image-new" src={post?.imageUrl} alt="" />
        </div>
        <div className="blog-title-new">{title}</div>
        <div className="blog-date-new">
          {post?.date && formatDate(post?.date)}
        </div>
        <div dangerouslySetInnerHTML={{ __html: post?.content }} />
        <div className="blog-author">
          <div className="blog-author-container">
            <img src={post?.author?.imageUrl} alt="" />
          </div>
          <div className="blog-author-content">
            <div className="blog-author-content-designation">
              {post?.author?.designation}

              <a href={post?.author?.profileUrl || "#"} target="_blank" rel="noopener noreferrer">
                <img src={linkd} alt="LinkedIn" />
              </a>

            </div>
            <div className="blog-author-content-title">
              {post?.author?.title}
            </div>
            <div className="blog-author-content-des">
              {post?.author?.description}
            </div>
          </div>
        </div>

        <h2 className="related-blogs">Related Blogs</h2>
        <div className="blog-grid">
          {blogs.slice(0, 3).map((item, itemIndex) => {
            return (
              <div
                key={item.id}
                className="blog-gird-item"
                onClick={() => {
                  const basePath = window.location.pathname.includes("/resiweb/")
                      ? `/resiweb/${username}/blog/${item.id}`
                      : `/blog/${item.id}`;
                    navigate(basePath);
                  window.location.reload();
                }}
              >
                <img src={item?.imageUrl} alt="" />
                <div className="blog-gird-item-date">
                  {item?.date && formatDate(item?.date)}
                </div>
                <div className="blog-gird-item-title">
                  {item?.title}
                </div>
              </div>
            );
          })}
        </div>

      </div>

      {/* Share your opinion */}
      {/*} <p className = "mt-6 text-sm text-gray-500 text-justify">
Have you found other solutions or have additional suggestions? 
Please share them with us by using the form below!
</p> */}
    </>
  );
}
